import React from "react";
import { useNavigate } from "react-router-dom";

const PaypalPaymentCancelledPage = () => {
    const navigate = useNavigate();

    return (
        <div className="container mx-auto max-w-lg p-6 bg-white rounded-lg shadow-md text-center">
            <h1 className="text-xl font-bold text-pegasusPurple mb-4">
                PayPal-Zahlung fehlgeschlagen!
            </h1>
            <p className="text-gray-600 mb-6">
                Die PayPal-Zahlung wurde abgebrochen. Das gewünschte Produkt wurde nicht
                gekauft. Bitte gehe zum Kalender und versuche es erneut!
            </p>
            <button
                onClick={() => navigate('/')}
                className="bg-pegasusPurple text-white py-2 px-6 rounded-lg font-semibold hover:bg-pegasusPurpleHover"
            >
                ZURÜCK ZUM KALENDER
            </button>
        </div>
    );
};

export default PaypalPaymentCancelledPage;